<!--*********************** Hotel CheckIN ******************** -->
<div class="row m-0 justify-content-center" style="padding-top: 25px;" *ngIf="isCheckIn && dato">
  <div class="col-12 p-0 m-0 container-items">
    <div
      class="d-flex container-item-card justify-content-between" style="border: 1px solid #c2c2c3; border-radius: 8px; gap: 25px;"
      [ngStyle]="{ 'margin-bottom': isStayRepeat ? '30px' : '0px' }"
    >
      <div
        class="flex-xl-grow-0 flex-grow-1 w-100"
        style="width: 100%; max-width: 175px; border-top-left-radius: 15px; border-bottom-left-radius: 15px"
      >
        <img
          style="
            width: 100%;
            height: 100%;
            cursor: pointer;
            object-fit: cover;
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
          "
          [src]="getImagenCover(dato)"
        />
      </div>

      <div class="hotel-item-description px-0" style="width: calc(100% - 190px)">
        <div class="d-flex- flex-column">
          <div class="d-flex justify-content-between align-items-start" [ngClass]="dato.categoryHotel === null ? 'mb-4' : 'mb-0'">
            <div class="pt-2">
              <p
                class="tittle mb-1"
                style="font-family: &quot;Poppins&quot;; font-size: 18.5px; font-weight: 600; line-height: 1.3; margin-top: 5px !important;
                max-width: 350px;"
              >
                Alojamiento en {{ dato.title }}
              </p>

              <div *ngIf="dato.categoryHotel != null" class="d-flex justify-content-start pb-1">
                <ng-container *ngFor="let star of starArray">
                  <img
                    class="mr-1"
                    *ngIf="star <= rate"
                    width="12"
                    height="12"
                    src="../../../../../../../assets/icons/itinerary/estrella-01.svg"
                    alt="estrella"
                  />
                  <img
                    class="mr-1"
                    *ngIf="star > rate"
                    width="12"
                    height="12"
                    style="filter: grayscale(1); opacity: 0.5"
                    src="../../../../../../../assets/icons/itinerary/estrella-01.svg"
                    alt="estrella"
                  />
                </ng-container>
              </div>
            </div>
            <div class="d-flex">
              <div class="pt-2 pr-3" *ngIf="roomStatuses.length > 0">
                <div class="d-flex align-items-center" style="gap: 5px">
                  <!-- Un solo status único: mostrar texto completo sin status-rounded -->
                  <ng-container *ngIf="uniqueRoomStatuses.length === 1">
                    <span
                      class="status status-sidebar"
                      [ngClass]="{
                        'product-status-saved': uniqueRoomStatuses[0].status_id === 1,
                        'product-status-reserved': uniqueRoomStatuses[0].status_id === 2,
                        'product-status-locked': uniqueRoomStatuses[0].status_id === 3,
                        'product-status-denied': uniqueRoomStatuses[0].status_id === 4,
                        'product-status-cancelled': uniqueRoomStatuses[0].status_id === 5,
                        'product-status-paid-agency': uniqueRoomStatuses[0].status_id === 6,
                        'product-status-paid-provider': uniqueRoomStatuses[0].status_id === 7,
                        'product-status-completed': uniqueRoomStatuses[0].status_id === 8
                      }"
                    >
                      {{ uniqueRoomStatuses[0].status }}
                    </span>
                  </ng-container>
                  <!-- Múltiples statuses únicos: mostrar primera letra con status-rounded -->
                  <ng-container *ngIf="uniqueRoomStatuses.length > 1">
                    <ng-container *ngFor="let roomStatus of roomStatuses">
                      <span
                        class="status status-sidebar status-rounded"
                        [ngClass]="{
                          'product-status-saved': roomStatus.status_id === 1,
                          'product-status-reserved': roomStatus.status_id === 2,
                          'product-status-locked': roomStatus.status_id === 3,
                          'product-status-denied': roomStatus.status_id === 4,
                          'product-status-cancelled': roomStatus.status_id === 5,
                          'product-status-paid-agency': roomStatus.status_id === 6,
                          'product-status-paid-provider': roomStatus.status_id === 7,
                          'product-status-completed': roomStatus.status_id === 8
                        }"
                      >
                        {{ roomStatus.status.charAt(0) }}
                      </span>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <div class="pt-2 pr-3" *ngIf="roomStatuses.length === 0">
                <span *ngIf="dato.status_id === 1" class="status status-sidebar status-rounded product-status-saved">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 2" class="status status-sidebar status-rounded product-status-reserved">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 3" class="status status-sidebar status-rounded product-status-locked">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 4" class="status status-sidebar status-rounded product-status-denied">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 5" class="status status-sidebar status-rounded product-status-cancelled">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 6" class="status status-sidebar status-rounded product-status-paid-agency">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 7" class="status status-sidebar status-rounded product-status-paid-provider">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 8" class="status status-sidebar status-rounded product-status-completed">{{ dato.status }}</span>
              </div>
              <div
                *ngIf="roomCount === 1 && dato.status_id !== 5"
                class="d-flex align-items-end justify-content-center"
                style="border-bottom: 1px solid #ccc; border-left: 1px solid #ccc; border-bottom-left-radius: 6px; padding:
                10px 15px; gap: 5px;"
              >
                <div
                  *ngIf="roomCount === 1" style="width: 25px; height: 25px">
                  <img
                    (click)="editRoom(dato)"
                    style="margin-top: -5px; cursor: pointer"
                    tooltip="Editar producto"
                    placement="bottom"
                    src="../../../../assets/icons/summary/edit.svg"
                    alt=""
                  />
                </div>
                <div
                  style="width: 25px; height: 25px;"
                  *ngIf="roomCount === 1 && dato.status_id === 1"
                >
                  <img
                    style="margin-top: -4px; cursor: pointer"
                    tooltip="Eliminar producto"
                    (click)="removeItem(dato)"
                    placement="bottom"
                    src="../../../../assets/icons/summary/delete.svg" alt=""
                  >
                </div>

                <div
                  style="width: 25px; height: 25px;"
                  *ngIf="roomCount === 1 && dato.status_id === 2"
                >
                  <img
                    style="
                      margin-top: -4px;
                      cursor: pointer;
                      filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                    "
                    tooltip="Cancelar producto"
                    (click)="removeItem(dato)"
                    placement="bottom"
                    src="../../../../assets/icons/itinerary-detail/04-01.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-stretch" style="margin-top: 15px; margin-bottom: 15px;">
          <div class="d-flex flex-column justify-content-center" style="width: 30%; min-height: 62px">
            <div class="d-flex align-items-start pt-3" style="width: 90%">
              <img width="25px" height="28px" style="margin-top: -5px" src="../../../../assets/icons/itinerary/lugar.svg" alt="" />
              <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif !important; font-size: 14px; font-weight: 500; line-height: 1.2">
                {{ dato?.form?.destination?.city_name }}
              </p>
            </div>

            <div class="d-flex font-inline flex-row">
              <span class="check mb-0">
                Check-in {{dato?.hotelAdditionalInfo[0]?.TimeInformation?.checkIn}} hs
              </span>
            </div>
          </div>

          <!-- Line Vertical -->
          <div style="width: 1px; background-color: #ccc;"></div>

          <div class="d-flex justify-content-center pt-3" style="width: 38%">
            <div class="d-flex flex-column">
              <div class="pl-2">
                <!-- ROOMS -->
                <ng-container *ngFor="let room of displayRooms; let ri = index; trackBy: trackByRoom">
                  <div class="mb-1">
                    <p
                      class="p-0 m-0"
                      style="
                        font-family: &quot;Rubik&quot;, serif !important;
                        font-size: 13px;
                        font-weight: 600; line-height: 1.2
                      "
                    >
                      <ng-container *ngIf="roomCount > 1">Hab {{ ri + 1 }} |&nbsp;</ng-container>
                      <ng-container *ngIf="roomCount === 1">1 Hab. |&nbsp;</ng-container>
                      {{ room.payloadUpdate.products[0].others.hotels.roomConfiguration[0].adults }} Adultos&nbsp;-&nbsp;
                      {{ room.payloadUpdate.products[0].others.hotels.roomConfiguration[0].children.length }} Niños
                    </p>
                    <p
                      class="m-0"
                      style="font-family: &quot;Rubik&quot;, serif !important; font-size: 13px; font-weight: 600; line-height: 1.2"
                    >{{ room.nights }} Noches</p>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Line Vertical -->
          <div style="width: 1px; background-color: #ccc;"></div>

          <div class="d-flex flex-column pr-3" style="width: 32%; align-items: flex-end; margin-top: -6px;">
            <p
              class="title-destiny-start text-nowrap mb-0"
              [ngClass]="{ 'pr-3': dato.status_id !== 5 }"
              style="
                font-family: &quot;Rubik&quot;, serif !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                line-height: 1.3;
                color: #666666;
              "
            >
              {{ currencyAgency?.code }}
            </p>
            <div class="d-flex align-items-center">
              <p
                class="title-destiny-start text-nowrap"
                style="color: #000000; font-family: &quot;Rubik&quot;, serif !important; font-weight: 600 !important; line-height: 1.3; font-size: 19.19px;"
              >
                <span *ngIf="dato.status_id !== 5">
                  {{ (roomCount > 1 ? totalPrice : getPrice(dato)) | number: "1.2-2" }}
                </span>
                <span *ngIf="dato.status_id === 5">
                  {{ 0 | number: "1.2-2" }}
                </span>
              </p>

              <ng-container *ngIf="dato.status_id !== 5">
                <usb-tooltip-convert-amount
                  [clientsSettingAppBooking]="clientSetting"
                  [currencyProduct]="currencyAgency?.code"
                  [valueProduct]="getPrice(dato)"
                >
                </usb-tooltip-convert-amount>
              </ng-container>
            </div>
            <div *ngIf="dato.status_id !== 5" class="d-flex flex-column justify-content-end align-items-end pb-1">
              <p
                class="mb-0"
                style="color: #b6b6b6;font-family: &quot;Rubik&quot;, serif !important; font-size: 12px; line-height: 1.3"
                [ngClass]="{ 'pr-3': dato.status_id !== 5 }"
                *ngIf="dato.currency !== currencyAgency?.code"
              >
                Imp. Incl.
              </p>
              <div *ngIf="dato.currency !== currencyAgency?.code" class="d-flex justify-content-end">
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600">
                  <span style="color: #616161;">{{ dato.currency }}</span>
                  {{
                    (((dato.netPriceBooking > 0 ? dato.netPriceBooking : dato.netPriceBookingFreeTax)) + (dato.room?.pricing?.taxesExcluded || 0)) | number: "1.2-2"
                  }}
                </p>
                <div class="info-tool d-flex flex-column position-relative">
                 <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                  <span class="tooltip-info shadow-md">
                    <div class="d-flex justify-content-center align-items-center px-2 py-1">
                      <p class="mb-0" style="font-size: 14px; color: black">{{ userService.messageProviderAmount }}</p>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ROOMS INFO - Solo mostrar si hay más de 1 habitación -->
  <div *ngIf="roomCount > 1" class="d-flex flex-column w-100" style="border-left: 1px solid #ababab; border-right: 1px solid #ababab; border-bottom: 1px solid #ababab; background-color: #FFFFFF; border-bottom-left-radius: 15px; border-bottom-right-radius: 15px; margin-top: -15px; padding: 35px 20px 20px;">
    <div class="mb-1">
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="d-flex flex-column">
          <h3
            class="m-0"
            style="
              font-family: 'Rubik';
              font-size: 15px;
              font-weight: 600;
              line-height: 1.2;
            "
          >
            Habitaciones Seleccionadas
          </h3>
          <p
            class="m-0"
            style="
              font-family: 'Rubik';
              font-size: 15px;
              font-weight: 400;
              line-height: 1.2;
            "
          >
            {{ roomCount }} Habitaciones
          </p>
        </div>

        <img
          width="10px"
          src="../../../../../../../assets/img/app/little-icons/arrow-down-black.svg"
          alt=""
          style="cursor: pointer; transition: transform 0.3s ease;"
          [style.transform]="roomsExpanded ? 'rotate(0deg)' : 'rotate(180deg)'"
          (click)="toggleRooms()"
        />
      </div>

      <div *ngIf="roomsExpanded" class="d-flex flex-column align-items-center pt-2">
        <ng-container *ngFor="let room of displayRooms; let lastRoom = last; trackBy: trackByRoom">
          <div [class]="!lastRoom ? 'mb-4 d-flex w-100' : 'd-flex w-100'" style="border-radius: 15px; border: 1px solid #ababab; overflow: hidden;">
            <div class="p-0" style="width: 20%;">
              <img style="width: 100%; height: 100%; max-height: 150px; object-fit: cover;" [src]="room.imagen" alt="" />
            </div>

            <div class="px-0" style="width: 80%;">
              <div class="row">
                <div class="col-7 my-2" style="border-right: 1px solid #ababab;">
                  <div style="padding: 15px 25px 0px;">
                    <h4
                      class="mb-3"
                      style="
                        font-family: 'Poppins';
                        font-weight: 600;
                        font-size: 15px;
                        line-height: 1.2;
                      "
                    >
                      {{ room.roomType }}
                    </h4>

                    <p
                      class="mb-3"
                      style="
                        font-size: 13px;
                        font-family: 'Rubik';
                        font-weight: 600;
                        line-height: 1.2;
                      "
                    > 1 Hab | {{room.room.adults}} Adultos - {{room.room.childrens}} niños | {{room.nights}} noches</p>

                    <p
                      *ngIf="room.boardName === 'Con desayuno'"
                      style="
                        margin: 0;
                        font-size: 14px;
                        font-family: 'Rubik';
                        font-weight: 500;
                        line-height: 1.2;
                        color: #5bca90;
                      "
                    >
                      Con Desayuno
                    </p>
                    <p
                      *ngIf="room.boardName !== 'Con desayuno'"
                      style="
                        margin: 0;
                        font-size: 14px;
                        font-family: 'Rubik';
                        font-weight: 500;
                        line-height: 1.2;
                        color: #5bca90;
                      "
                    >
                      Sin Desayuno
                    </p>
                  </div>
                </div>

                <div class="col-5">
                  <div class="row h-100" style="padding-bottom: 15px;">
                    <div class="col-7 h-100">
                      <div class="d-flex flex-column align-items-end h-100 pt-3">
                        <!-- Status -->
                        <span
                          class="mb-3"
                          style="display: inline-block; font-family: 'Rubik'; font-size: 13px; font-weight: 500; line-height: 1.2;"
                        >
                          <span *ngIf="room.status_id === 1" class="status status-sidebar product-status-saved" style="font-size: 10px;">{{ room.status }}</span>
                          <span *ngIf="room.status_id === 2" class="status status-sidebar product-status-reserved" style="font-size: 10px;">{{ room.status }}</span>
                          <span *ngIf="room.status_id === 3" class="status status-sidebar product-status-locked" style="font-size: 10px;">{{ room.status }}</span>
                          <span *ngIf="room.status_id === 4" class="status status-sidebar product-status-denied" style="font-size: 10px;">{{ room.status }}</span>
                          <span *ngIf="room.status_id === 5" class="status status-sidebar product-status-cancelled" style="font-size: 10px;">{{ room.status }}</span>
                          <span *ngIf="room.status_id === 6" class="status status-sidebar product-status-paid-agency" style="font-size: 10px;">{{ room.status }}</span>
                          <span *ngIf="room.status_id === 7" class="status status-sidebar product-status-paid-provider" style="font-size: 10px;">{{ room.status }}</span>
                          <span *ngIf="room.status_id === 8" class="status status-sidebar product-status-completed" style="font-size: 10px;">{{ room.status }}</span>
                        </span>

                        <div class="d-flex flex-column align-items-end">
                          <!-- Currency -->
                          <span
                            style="
                              font-family: 'Rubik';
                              font-size: 13px;
                              font-weight: 500;
                              line-height: 1.2;
                              color: #616161;
                            "
                          >
                            {{ currencyAgency?.code }}
                          </span>
                          <!-- Price -->
                          <p
                            style="
                              font-family: 'Rubik';
                              font-size: 18px;
                              font-weight: 600;
                              line-height: 1.2;
                              color: #000000;
                            "
                            class="m-0"
                          >
                            <ng-container *ngIf="room.status_id !== 5">
                              {{ getPrice(room) | number: "1.2-2" }}
                            </ng-container>
                            <ng-container *ngIf="room.status_id === 5">0.00</ng-container>
                          </p>
                          <!-- Imp. Incl. -->
                          <span
                            *ngIf="room.status_id !== 5 && room.currency !== currencyAgency?.code"
                            style="
                              font-family: 'Rubik';
                              font-size: 11px;
                              font-weight: 400;
                              line-height: 1.2;
                              color: #616161;
                            "
                          >
                            Imp. Incl.
                          </span>
                          <!-- Precio en moneda original si difiere -->
                          <p
                            *ngIf="room.status_id !== 5 && room.currency !== currencyAgency?.code"
                            class="m-0 d-flex align-items-center"
                            style="
                              gap: 2px;
                              font-family: 'Rubik';
                              font-size: 11px;
                              font-weight: 500;
                              line-height: 1.2;
                              color: #000000;
                            "
                          >
                            <span style="color: #616161;">{{ room.currency }}</span>
                            {{ ((room.optionNightsNetTotalProf > 0 ? room.optionNightsNetTotalProf : room.optionNightNetTotalFreeTax) + (room.room?.pricing?.taxesExcluded || 0)) | number: "1.2-2" }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="col-5 pl-0">
                      <div class="d-flex justify-content-end">
                        <div
                          *ngIf="room.status_id !== 5"
                          class="d-inline-flex justify-content-end pr-3 pl-3 pb-2 pt-2"
                          style="border-bottom: 2px solid #ccc; border-left: 1px solid #ccc; border-bottom-left-radius: 6px; gap: 5px"
                        >
                          <div
                            *ngIf="room.status_id === 1" style="width: 25px; height: 25px">
                            <img
                              (click)="editRoom(room)"
                              style="margin-top: -5px; cursor: pointer"
                              tooltip="Editar producto"
                              placement="bottom"
                              src="../../../../assets/icons/summary/edit.svg"
                              alt=""
                            />
                          </div>
                          <div style="width: 25px; height: 25px" *ngIf="room.status_id === 1">
                            <img
                              style="margin-top: -4px; cursor: pointer"
                              tooltip="Eliminar producto"
                              placement="bottom"
                              (click)="removeRoom(room)"
                              src="../../../../assets/icons/summary/delete.svg"
                              alt=""
                            />
                          </div>
                          <div style="width: 25px; height: 25px" *ngIf="room.status_id === 2">
                            <img
                              style="
                                margin-top: -4px;
                                cursor: pointer;
                                filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                              "
                              tooltip="Cancelar producto"
                              placement="bottom"
                              (click)="cancelRoom(room)"
                              src="../../../../assets/icons/itinerary-detail/04-01.svg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
